import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";
import { useNotifications } from "context/notifications";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import PlaceholderPage from "components/PlaceholderPage";
import {
  NotificationsActions,
  NotificationsTable,
  NotificationsTiles,
} from "../components";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "notifications-content";

const actions_admin = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const actions_webmaster = [
  {
    type: "send_notification",
  },
];

const NotificationsContent = () => {
  const { user, websites } = useApp();
  const { t } = useTranslation();

  const { max } = useResponsive();

  const { init_loading } = useNotifications();

  const [websiteInfoId, setWebsiteInfoId] = useState(null);

  const actions_client = [
    {
      label: t("Add new website"),
      href: "/websites/new",
      event: () =>
        window.gtag("event", "new_website", {
          click_text: t("Add new website"),
          click_url: `/websites/new`,
        }),
    },
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  return (
    <>
      <DashboardContentLayout
        header={
          websites?.length > 0
            ? {
                label: t("Notifications"),
                description: t(
                  "Information about your website, tasks, and more.",
                ),
                actions: !max.lg ? <NotificationsActions /> : null,
              }
            : null
        }
        loading={init_loading}
        actions={
          user?.type === "client"
            ? actions_client
            : user?.type === "webmaster"
              ? actions_webmaster
              : actions_admin
        }
      >
        {websites?.length === 0 && user?.type === "client" ? (
          <PlaceholderPage
            title={t("Add your website to Webinity")}
            text={t(
              "Just a few simple steps away from peace of mind with managing your website or store. Let us take care of your website, and you enjoy the peace and time to grow your business.",
            )}
            button={{
              label: t("Add website"),
              href: "/websites/new",
            }}
          />
        ) : (
          <div className={mainClass}>
            {!max.lg ? (
              <NotificationsTable setWebsiteInfoId={setWebsiteInfoId} />
            ) : (
              <NotificationsTiles />
            )}
          </div>
        )}
        {websites?.length > 0 && max.sm && <ScrollTopMobile />}
      </DashboardContentLayout>

      <WebsiteInfoModal
        id={websiteInfoId}
        isOpen={!!websiteInfoId}
        onClose={() => setWebsiteInfoId(null)}
      />
    </>
  );
};

export default NotificationsContent;
